import { defineStore } from 'pinia'

export const departments = defineStore('prod_deps', {
    state: () => {
        return { prod_deps: null }
    },
    actions: {
        get() {
            return this.prod_deps
        },
        set(value) {
            this.prod_deps = value
        }
    },
})
export const selected_dep = defineStore('prod_selected_dep', {
    state: () => {
        return { prod_selected_dep: null }
    },
    actions: {
        get() {
            return this.prod_selected_dep
        },
        set(value) {
            this.prod_selected_dep = value
        }
    },
})

export const selected_range = defineStore('prod_selected_date', {
    state: () => {
        return { prod_selected_date: null }
    },
    actions: {
        get() {
            return this.prod_selected_date
        },
        set(value) {
            this.prod_selected_date = value
        }
    },
})
export const report_dep = defineStore('prod_report', {
    state: () => {
        return { prod_report: null }
    },
    actions: {
        get() {
            return this.prod_report
        },
        set(value) {
            this.prod_report = value
        }
    },
})
